<template>
  <a-modal
    :title="title"
    width="1200px"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    centered
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <search-render
      v-if="searchConfig"
      :form="searchConfig"
      :model="search_modelRef"
      :options="searchConfigOptions"
      :validateInfos="searchValidateInfos"
      @search="search"
    />
    <a-row>
      <a-col :span="12">
        <a-table
          bordered="true"
          size="small"
          :loading="state.loading"
          :scroll="{ y: 400, x: columnState.tableWidth }"
          :row-selection="rowSelection"
          :columns="dynamicColumns"
          row-key="id"
          :data-source="state.dataSource"
          :pagination="{
            current: state.current,
            pageSize: state.pageSize,
            total: state.total,
          }"
          @change="handleTableChange"
        >
          <template
            v-for="item in slotList"
            v-slot:[item.slotName]="{ index, text }"
            :key="item.slotName"
          >
            <span v-if="item.slotName === 'index'">
              {{ index + 1 + state.pageSize * (state.current - 1) }}
            </span>
            <span v-if="item.type === 'custom'">
              {{ item['field_' + text] }}
            </span>
            <span v-if="item.type === 'datetime'">
              {{ getDateTime(text) }}
            </span>
            <span v-if="item.type === 'date'">
              {{ getDate(text) }}
            </span>
            <span v-if="item.type === 'full_date'">
              {{ getFullDate(text) }}
            </span>
            <span v-if="item.type === 'time'">
              {{ getTime(text) }}
            </span>
            <a-tag color="green" v-if="text && item.type === 'boolean'">{{ item.name1 }}</a-tag>
            <a-tag color="red" v-if="!text && item.type === 'boolean'">{{ item.name2 }}</a-tag>
            <template v-if="item.type === 'list'">
              <a-tag color="#87d068" v-for="obj in text" :key="obj.id" style="margin-bottom: 1px">
                {{ obj.name }}
              </a-tag>
            </template>
          </template>
        </a-table>
      </a-col>

      <a-col :span="12">
        <a-table
          bordered="true"
          size="small"
          :loading="state2.loading"
          :scroll="{ y: 400, x: columnState2.tableWidth }"
          :row-selection="rowSelection2"
          :columns="dynamicColumns2"
          row-key="id"
          :data-source="state2.dataSource"
          :pagination="{
            current: state2.current,
            pageSize: state2.pageSize,
            total: state2.total,
          }"
          @change="handleTableChange2"
        >
          <template
            v-for="item in slotList"
            v-slot:[item.slotName]="{ index, text }"
            :key="item.slotName"
          >
            <span v-if="item.slotName === 'index'">
              {{ index + 1 + state2.pageSize * (state2.current - 1) }}
            </span>
            <span v-if="item.type === 'custom'">
              {{ item['field_' + text] }}
            </span>
            <span v-if="item.type === 'datetime'">
              {{ getDateTime(text) }}
            </span>
            <span v-if="item.type === 'date'">
              {{ getDate(text) }}
            </span>
            <span v-if="item.type === 'full_date'">
              {{ getFullDate(text) }}
            </span>
            <span v-if="item.type === 'time'">
              {{ getTime(text) }}
            </span>
            <a-tag color="green" v-if="text && item.type === 'boolean'">{{ item.name1 }}</a-tag>
            <a-tag color="red" v-if="!text && item.type === 'boolean'">{{ item.name2 }}</a-tag>
            <template v-if="item.type === 'list'">
              <a-tag color="#87d068" v-for="obj in text" :key="obj.id" style="margin-bottom: 1px">
                {{ obj.name }}
              </a-tag>
            </template>
          </template>
        </a-table>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, watch } from 'vue';
// import { ColumnProps } from 'ant-design-vue/es/table/interface';
import { useFetchData } from '@/utils/hooks/useFetchData';
import { useForm } from 'ant-design-vue/es/form';
import { Pagination, TableColumn, TableColumnSortOrder, TableFilters } from '@/typing';
import { useStore } from 'vuex';
import { useTableDynamicColumns } from '@/utils/hooks/useTableColumn';
import getFormConfig from '@/components/form-modal/customSelecteModal/select-mjstore-orderusedrecord';

// type Key = ColumnProps['key'];

interface DataType {
  id: number;
  key: any;
  name: string;
}

export default defineComponent({
  name: 'SelectMjstoreOrderusedrecord',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    mode: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },

    init_model: {
      type: Object,
      default: () => {},
    },
    field_status: {
      type: Object,
      default: () => {},
    },
    watch: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    const loading = ref(false);
    const store = useStore();
    const current_org = store.getters['user/current_org'];
    const { searchConfig, searchConfigOptions, getData, columns, slotList } = getFormConfig();
    const search_modelRef = reactive({
      ...searchConfig.model,
      org_id: current_org.id,
      is_active: true,
      ...props.init_model,
    });

    for (let field of searchConfig.fields) {
      if (props.field_status && props.field_status.hasOwnProperty(field.name)) {
        if (props.field_status[field.name] == 0) {
          field.disabled = true;
          field.hidden = false;
        } else if (props.field_status[field.name] == 1) {
          field.disabled = false;
          field.hidden = true;
        } else {
          field.disabled = false;
          field.hidden = false;
        }
      }
    }

    const { state: columnState, dynamicColumns } = useTableDynamicColumns(
      columns as TableColumn[],
      {
        checkAll: false,
        needRowIndex: false,
      },
    );
    const { state: columnState2, dynamicColumns: dynamicColumns2 } = useTableDynamicColumns(
      columns as TableColumn[],
      {
        checkAll: false,
        needRowIndex: false,
      },
    );

    const modalRef = reactive({
      visible: false,
      selectedRows: new Array<number>(),
      selectedRowsKey: new Array<number>(),
      selectedRowsKey2: new Array<number>(),
      selectedRowsTotal: new Array<any>(),
    });

    const rowSelection = {
      type: props.mode == 'default' ? 'radio' : props.mode == 'multiple' ? 'checkbox' : 'checkbox',
      columnWidth: '30px',
      selectedRowKeys: modalRef.selectedRowsKey,
      onChange: (selectedRowKeys: any[], selectedRows: DataType[]) => {
        // modalRef.selectedRowsKey.length = 0;
        modalRef.selectedRowsTotal.length = 0;
        modalRef.selectedRowsKey2.length = 0;
        let remove_key: Array<number> = modalRef.selectedRowsKey.filter(
          item => selectedRowKeys.indexOf(Number(item)) == -1,
        );
        modalRef.selectedRowsTotal = modalRef.selectedRowsTotal.filter(
          item => remove_key.indexOf(item.id) == -1,
        );
        selectedRows.forEach((item: DataType) => {
          if (modalRef.selectedRowsKey.indexOf(item.id) == -1) {
            modalRef.selectedRowsTotal.push(item);
          }
        });

        modalRef.selectedRowsKey.length = 0;
        selectedRows.forEach((item: DataType) => {
          modalRef.selectedRowsKey.push(item.id);
        });
      },
    };

    const rowSelection2 = {
      type: props.mode == 'default' ? 'radio' : props.mode == 'multiple' ? 'checkbox' : 'checkbox',
      columnWidth: '30px',
      selectedRowKeys: modalRef.selectedRowsKey2,
      onChange: (selectedRowKeys: any[], selectedRows: DataType[]) => {
        // modalRef.selectedRowsKey.length = 0;
        modalRef.selectedRowsTotal.length = 0;
        modalRef.selectedRowsKey.length = 0;
        let remove_key: Array<number> = modalRef.selectedRowsKey2.filter(
          item => selectedRowKeys.indexOf(Number(item)) == -1,
        );
        modalRef.selectedRowsTotal = modalRef.selectedRowsTotal.filter(
          item => remove_key.indexOf(item.id) == -1,
        );
        selectedRows.forEach((item: DataType) => {
          if (modalRef.selectedRowsKey2.indexOf(item.id) == -1) {
            modalRef.selectedRowsTotal.push(item);
          }
        });

        modalRef.selectedRowsKey2.length = 0;
        selectedRows.forEach((item: DataType) => {
          modalRef.selectedRowsKey2.push(item.id);
        });
      },
    };

    const {
      reload,
      setPageInfo,
      context: state,
    } = useFetchData(getData, {
      current: 1,
      pageSize: 20,
      tableSize: 'middle', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        ...search_modelRef,
        p_type: 20,
      },
    });
    const {
      reload: reload2,
      setPageInfo: setPageInfo2,
      context: state2,
    } = useFetchData(getData, {
      current: 1,
      pageSize: 20,
      tableSize: 'middle', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        ...search_modelRef,
        p_type: [0, 10],
      },
    });
    watch(
      () => state.dataSource,
      () => {
        let total_ids: Array<number> = modalRef.selectedRowsTotal.map(item => item.id);
        state.dataSource.map((item: any) => {
          if (total_ids.indexOf(item.id) > -1) {
            modalRef.selectedRowsKey.push(item.id);
          }
        });
      },
    );
    watch(
      () => state2.dataSource,
      () => {
        let total_ids: Array<number> = modalRef.selectedRowsTotal.map(item => item.id);
        state2.dataSource.map((item: any) => {
          if (total_ids.indexOf(item.id) > -1) {
            modalRef.selectedRowsKey2.push(item.id);
          }
        });
      },
    );

    const handleTableChange = (
      { current, pageSize }: Pagination,
      filters: TableFilters,
      sorter: TableColumnSortOrder,
    ) => {
      console.log(sorter);
      setPageInfo({
        current,
        pageSize,
        ...filters,
        ...search_modelRef,
        p_type: 20,
      });

      reload();
    };
    const handleTableChange2 = (
      { current, pageSize }: Pagination,
      filters: TableFilters,
      sorter: TableColumnSortOrder,
    ) => {
      console.log(sorter);
      setPageInfo2({
        current,
        pageSize,
        ...filters,
        ...search_modelRef,
        p_type: [0, 10],
      });

      reload2();
    };

    const { validateInfos: searchValidateInfos } = useForm(search_modelRef, {});

    const search = () => {
      setPageInfo({
        current: 1,
        ...search_modelRef,
        p_type: 20,
      });
      reload();
      setPageInfo2({
        current: 1,
        ...search_modelRef,
        p_type: [0, 10],
      });
      reload2();
    };

    const handleSubmit = (e: Event) => {
      e.preventDefault();
      modalRef.visible = false;
      if (modalRef.selectedRows == undefined) {
        modalRef.selectedRows = new Array<number>();
      }
      modalRef.selectedRows.length = 0;
      modalRef.selectedRowsTotal.map((item: any) => modalRef.selectedRows.push(item.id as number));
      emit('ok', modalRef.selectedRows[0]);
    };

    // 接口返回时间，格式优化
    const getDateTime = (time: any) => {
      if (time && new Date().getFullYear().toString() == time.substring(0, 4)) {
        time = time.substring(5, 16);
      } else if (time) {
        time = time.substring(0, 16);
      }
      return time;
    };
    const getDate = (time: any) => {
      if (time && new Date().getFullYear().toString() == time.substring(0, 4)) {
        time = time.substring(5, 10);
      } else if (time) {
        time = time.substring(0, 10);
      }
      return time;
    };
    const getFullDate = (time: any) => {
      if (time) {
        time = time.substring(0, 10);
      }
      return time;
    };
    const getTime = (time: any) => {
      if (time) {
        time = time.substring(0, 5);
      }
      return time;
    };
    const handleCancel = () => {
      emit('cancel');
    };
    return {
      props,
      modalRef,
      state,
      state2,
      loading,
      getDateTime,
      getDate,
      getFullDate,
      getTime,
      search,
      handleSubmit,
      handleTableChange,
      handleTableChange2,
      rowSelection,
      rowSelection2,
      searchValidateInfos,
      search_modelRef,
      searchConfig,
      searchConfigOptions,
      columnState,
      dynamicColumns,
      columnState2,
      dynamicColumns2,
      slotList,
      handleCancel,
    };
  },
});
</script>
